import service from '@/utils/request'; // @Tags SysDictionary
// @Summary 创建SysDictionary
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.SysDictionary true "创建SysDictionary"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /sysDictionary/createSysDictionary [post]

export var createSysDictionary = function createSysDictionary(data) {
  return service({
    url: '/sysDictionary/createSysDictionary',
    method: 'post',
    data: data
  });
}; // @Tags SysDictionary
// @Summary 删除SysDictionary
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.SysDictionary true "删除SysDictionary"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /sysDictionary/deleteSysDictionary [delete]

export var deleteSysDictionary = function deleteSysDictionary(data) {
  return service({
    url: '/sysDictionary/deleteSysDictionary',
    method: 'post',
    data: data
  });
}; // @Tags SysDictionary
// @Summary 更新SysDictionary
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.SysDictionary true "更新SysDictionary"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /sysDictionary/updateSysDictionary [put]

export var updateSysDictionary = function updateSysDictionary(data) {
  return service({
    url: '/sysDictionary/updateSysDictionary',
    method: 'put',
    data: data
  });
}; // @Tags SysDictionary
// @Summary 用id查询SysDictionary
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.SysDictionary true "用id查询SysDictionary"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /sysDictionary/findSysDictionary [get]

export var findSysDictionary = function findSysDictionary(params) {
  return service({
    url: '/sysDictionary/findSysDictionary',
    method: 'get',
    params: params
  });
}; // @Tags SysDictionary
// @Summary 分页获取SysDictionary列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取SysDictionary列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /sysDictionary/getSysDictionaryList [get]

export var getSysDictionaryList = function getSysDictionaryList(params) {
  return service({
    url: '/sysDictionary/getSysDictionaryList',
    method: 'get',
    params: params
  });
};